/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from './contexts/AuthContext';
import { SearchProvider } from './contexts/SearchContext';

// Gestionnaire d'erreur global pour capturer les erreurs de port déconnecté
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && 
      event.error.message.includes('disconnected port object')) {
    // Ignorer silencieusement les erreurs de port déconnecté
    event.preventDefault();
    console.warn('Port disconnection error ignored:', event.error.message);
    return false;
  }
});

// Gestionnaire pour les erreurs non gérées des promesses
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && 
      event.reason.message.includes('disconnected port object')) {
    // Ignorer silencieusement les erreurs de port déconnecté
    event.preventDefault();
    console.warn('Port disconnection promise rejection ignored:', event.reason.message);
    return false;
  }
});

ReactDOM.render(
  <BrowserRouter>
    <AuthProvider>
      <SearchProvider>
        <App />
      </SearchProvider>
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById("root"),
);
